module.exports = __webpack_public_path__ + "media/packs/images/flags/MR-c443c0c46fe2e561edc72d09820e8b08.png";